import React from 'react';
import {
  TiSocialFacebook,
  TiSocialLinkedin,
  TiSocialTwitter,
  TiSocialInstagram,
  
} from 'react-icons/ti';

import logo from '../assets/logo.png';
import '../styles/footer.css'

const Footer = () => {
  return (
   <footer>
    <div classname='footer'>
      <div className='sb_footer footer_padding'>
        <div className='sb_footer-links'>
          <div className='sb_footer-links_div'>
            <span className='logo'>
              <img src={logo} alt='logo' height='40px' width='40px' />
              <h3>Academify</h3>

            </span>
              <p className='word' > We hope to make past questions accessible all student and we aim for this site to be a one site stop for academic excellence </p>
           <span className='row'>
            <a href='facebook'>  <span className='icons' > <TiSocialFacebook/> </span></a>
            <a href='Twitter'>  <span className='icons' ><TiSocialTwitter/></span> </a>
            <a href='LinkedIn'> <span className='icons' > <TiSocialLinkedin/></span> </a>
            <a href='Instagram'> <span className='icons' > <TiSocialInstagram/></span> </a>

           </span>
            
          </div>
          <div className='sb_footer-links_div'>
            <h4> Educational Tools</h4>
            <a href='#ss'> Learning Library </a>
            <a href='#dfhj'> Past Questions </a>
            <a href='#bw'> Take a Test </a>
            <a href='#he'> Courses </a>

          </div>
          <div className='sb_footer-links_div'>
            <h4> Support </h4>
            <a href='#eh'> Help Center </a>
            <a href='#eh'> Pricing </a>
            <a href='#jh3u'> For School </a>
            <a href='#asy'> Give gift </a>

          </div>
          <div className='sb_footer-links_div'>
            <h4> About </h4>
            <a href='#g3e'> Author </a>
            <a href='#hyq'> Press </a>
            <a href='#3haqy'> Reviews </a>

          </div>
          <div className='sb_footer-links_div'>
            <h4> Contact </h4>
            <a href='#hs'> Email </a>
            <a href='#kjd'> Phone number </a>
            

          </div>
        </div>
        <hr></hr>

        <div className='sb_footer-below'>
          <div className='sb_footer-copyright'>
            <p>
              @{new Date().getFullYear()} Academify. All rights reserved.
            </p>
          </div>
          <div className='sb_footer-below-links'>
            <a href='terms'><div><p> Cookie Policy </p></div></a>
            <a href='terms'><div><p> Cookie Policy </p></div></a>
        </div>
      </div>
    </div>
    </div>

   </footer>
  )
}

export default Footer